/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import Form from "../../../shared/forms/Form";
import Field from "../../../shared/forms/Field";
import FormDropDown from "../../../shared/forms/FormFields/FormDropDown";
import FormCalendar from "../../../shared/forms/FormFields/FormCalendar";
import FormTextArea from "../../../shared/forms/FormFields/FormTextArea";

const obtenerValor = (obj, camelCase, pascalCase) => {
    return obj?.[camelCase] ?? obj?.[pascalCase] ?? null;
};

const GeneralSalidaEmpleado = ({
    value,
    onChange,
    onValidate,
    puedeEditar,
    errors,
    submitted
}) => {
    return (
        <>
            <Form
                columns={4}
                values={value}
                onChange={onChange}
                onValidate={onValidate}
                formDisabled={!puedeEditar}
            >
                <Field
                    field="empleadoId"
                    label="Empleado"
                    cols={2}
                    required={true}
                    errors={errors?.empleadoId}
                    className={submitted && errors?.empleadoId ? "p-invalid" : ""}
                    render={({ onParentChange, ...props }) => (
                        <FormDropDown
                            {...props}
                            source="empleadosSalidas"
                            params={{
                                todasLasEmpresas: true
                            }}
                            valueById
                            onChange={(id, empleado) => {
                                const nombreEmpleado =
                                    obtenerValor(empleado, "nombre", "Nombre") ?? "";

                                const departamentoId =
                                    obtenerValor(empleado, "departamentoId", "DepartamentoId");

                                const jefeInmediatoId =
                                    obtenerValor(empleado, "jefeInmediatoId", "JefeInmediatoId");

                                const jefeInmediato =
                                    obtenerValor(empleado, "jefeInmediato", "JefeInmediato") ?? "";

                                if (!id) {
                                    onParentChange({
                                        empleadoId: null,
                                        nombreCompleto: "",
                                        departamentoId: null,
                                        jefeInmediatoId: null,
                                        jefeInmediato: ""
                                    });

                                    return;
                                }

                                onParentChange({
                                    empleadoId: id,
                                    nombreCompleto: nombreEmpleado,

                                    departamentoId:
                                        departamentoId && departamentoId > 0
                                            ? departamentoId
                                            : null,

                                    jefeInmediatoId:
                                        jefeInmediatoId && jefeInmediatoId > 0
                                            ? jefeInmediatoId
                                            : null,

                                    jefeInmediato: jefeInmediato
                                });
                            }}
                        />
                    )}
                />

                <Field
                    field="departamentoId"
                    label="Departamento"
                    cols={2}
                    render={(props) => (
                        <FormDropDown
                            {...props}
                            source="departamentos"
                            valueById
                            disabled
                        />
                    )}
                />

                <Field
                    field="fechaHoraSalida"
                    label="Fecha y hora de salida"
                    render={FormCalendar}
                    required={true}
                    cols={2}
                    showTime
                    hourFormat="24"
                />

                <Field
                    field="tipoId"
                    label="Tipo de salida"
                    cols={2}
                    required={true}
                    errors={errors?.tipoId}
                    className={submitted && errors?.tipoId ? "p-invalid" : ""}
                    render={(props) => (
                        <FormDropDown
                            {...props}
                            source="tiposSalidaEmpleado"
                            valueById
                        />
                    )}
                />

                <Field
                    field="jefeInmediatoId"
                    label="Jefe inmediato"
                    cols={2}
                    render={(props) => (
                        <FormDropDown
                            {...props}
                            source="jefes"
                            params={{
                                todasLasEmpresas: true
                            }}
                            valueById
                            disabled
                        />
                    )}
                />

                <Field
                    label="Destino"
                    field="destino"
                    required={true}
                    render={FormTextArea}
                    cols={4}
                    rows={2}
                    maxLength={300}
                />

                <Field
                    label="Motivos"
                    field="motivos"
                    render={FormTextArea}
                    cols={4}
                    rows={3}
                    maxLength={1000}
                />

                <Field
                    label="Comentarios"
                    field="comentarios"
                    render={FormTextArea}
                    cols={4}
                    rows={3}
                    maxLength={1000}
                />
            </Form>
        </>
    );
};

export default GeneralSalidaEmpleado;